const BLOCK_TAGS = new Set(['P', 'DIV', 'SECTION', 'ARTICLE', 'HEADER', 'FOOTER', 'ASIDE', 'BLOCKQUOTE', 'PRE', 'H1', 'H2', 'H3', 'H4', 'H5', 'H6']);

const normalizePdfText = (text: string): string =>
  text
    .replace(/\r\n/g, '\n')
    .replace(/\r/g, '\n')
    .replace(/[\u00A0\u1680\u2000-\u200A\u202F\u205F\u3000]/g, ' ')
    .replace(/\u200B|\u200C|\u200D|\uFEFF/g, '')
    .replace(/\u2060/g, '')
    .replace(/\u00AD/g, '')
    .replace(/[\u2010\u2011\u2012\u2015\u2212]/g, '-')
    .replace(/\u2022|\u25CF|\u25CB|\u25AA|\u25AB/g, '\u00b7')
    .replace(/\u2023|\u2043|\u2219/g, '-')
    .replace(/\u2014/g, '--')
    .replace(/\u2013/g, '-')
    .replace(/\u201C|\u201D/g, '"')
    .replace(/\u2018|\u2019/g, "'")
    .replace(/\u2026/g, '...')
    .replace(/\t/g, '  ')
    .replace(/[ \t]+\n/g, '\n')
    .replace(/\n[ \t]+/g, '\n')
    .replace(/[ \t]{2,}/g, ' ')
    .replace(/\n{3,}/g, '\n\n')
    .trim();

const serializeNode = (node: Node): string => {
  if (node.nodeType === Node.TEXT_NODE) {
    return node.textContent || '';
  }

  if (node.nodeType !== Node.ELEMENT_NODE) {
    return '';
  }

  const element = node as HTMLElement;
  const tagName = element.tagName.toUpperCase();

  if (tagName === 'BR') {
    return '\n';
  }

  const content = Array.from(element.childNodes).map(serializeNode).join('');

  if (tagName === 'LI') {
    const trimmed = content.trim();
    return trimmed ? `- ${trimmed}\n` : '';
  }

  if (tagName === 'UL' || tagName === 'OL') {
    return `${content.trim()}\n\n`;
  }

  if (BLOCK_TAGS.has(tagName)) {
    const trimmed = content.trim();
    return trimmed ? `${trimmed}\n\n` : '\n';
  }

  return content;
};

export const htmlToPdfText = (rawHtml: string): string => {
  if (!rawHtml) return '';
  const container = document.createElement('div');
  container.innerHTML = rawHtml;
  return normalizePdfText(Array.from(container.childNodes).map(serializeNode).join(''));
};

export const elementToPdfText = (element: Element | null): string => {
  if (!element) return '';
  return normalizePdfText(Array.from(element.childNodes).map(serializeNode).join(''));
};
